/*!SECTION
	@info : 사육환결별 그래프 페이지
	@developed by : Leo(WiseLake)
	@date : 2024-02-20
*/
import { useState, useEffect, useCallback, useMemo } from 'react';
import Select from 'react-select';
import styled from "styled-components/macro";
import axios from 'axios';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Chart, registerables } from 'chart.js';
import LineChart from "../../components/LineChart ";
import LineChart2 from "../../components/LineChart2";
import LineChart3 from "../../components/LineChart3";
import LineChart4 from "../../components/LineChart4";

// interface EnvirdataCrossConProps {
//   insects: any[];
//   setSelectedOption: (option: any) => void;
//   onChangfunc: (event: React.ChangeEvent<HTMLInputElement>) => void;
// }

//! 공통 사용을 위한 전역 XX 생성
dayjs.locale('ko');
dayjs.extend(utc);
Chart.register(...registerables);


interface EnvirdataCrossConProps {
	setECCstate: (option: any) => void;
};

const EnvirdataCrossCon: React.FC<EnvirdataCrossConProps> = ({ setECCstate }) => {
	/** 사전 필요 데이터 정의
	 * * 농장 데이터를 기반으로 하위 정보들을 불러옴
	 * *. *. 사육실 정보
	 * *. *. 사육 구역 정보
	 * *. *. *. 위 선택(selectTagList)에 따른 환경 정보
	 * *. *. *. *. 환경 정보에 따른 그래프 그리기
	*/

	//! 데이터를 관리하기 위한 state 선언

	// 농장 정보를 가진 localStorage를 가져옴
	const targetFarmInfo = JSON.parse(localStorage.getItem("targetfarmInfo") || "{}");
	const targetFarmInfoMemo = useMemo(() => targetFarmInfo, [JSON.stringify(targetFarmInfo)]);

	// 사육실 Combobox List 정보를 담는 state
	const [placeList, setPlaceList] = useState<any[]>([]);

	// 사육구역 Combobox List 정보를 담는 state
	const [placePartList, setPlacePartList] = useState<any[]>([]);

	// 환경 정보를 담는 state
	const [envirDataList, setEnvirDataList] = useState<any[]>([]);

	// 선택된 option을 담는 state
	const [selectFarm, setSelectFarm] = useState<number>(targetFarmInfoMemo.placeId);
	const [selectPlace, setSelectPlace] = useState<number>(0);
	const [selectPlacePart, setSelectPlacePart] = useState<number>(0);

	// 선택된 Tag의 tagId(number) List를 담는 state
	const [selectTagList, setSelectTagList] = useState<any[]>([]);

	// 각각의 태그 담기
	const [selectTempTags, setTemperatureTags] = useState<any[]>([]);
	const [selectHumidTags, setHumidityTags] = useState<any[]>([]);
	const [selectCo2Tags, setCO2Tags] = useState<any[]>([]);
	const [selectEtcTags, setEtcTags] = useState<any[]>([]);

	// Chart 조회를 위한 options state
	const [chartUnitList, setChartUnitList] = useState<string[]>(['시간', '일', '주', '월']);
	const [chartUnit, setChartUnit] = useState<string>('시간');
	const [chartStartDate, setChartStartDate] = useState<string>(dayjs().format('YYYY-MM-DD'));
	const [chartEndDate, setChartEndDate] = useState<string>(dayjs().format('YYYY-MM-DD'));
	const [chartTime, setChartTime] = useState<string>(dayjs().format('HH:mm'));

	//! API
	// 농장 정보를 기반으로 사육실 정보, 사육구역을 가져오는 API	
	const getPlaceInfo = async (placeId: number) => {
		try {
			const response = await axios.get(`/ifactory/api/place/specificplace?placeId=${placeId}`);
			return response.data;
		} catch (error: any) {
			console.error(error);
		}
	};

	// 사육구역을 기반으로 환경 정보를 가져오는 API
	const getTag = async (placeId: number) => {
		try {
			const response = await axios.get(`/ifactory/api/tag/${placeId}`);
			return response.data;
		} catch (error: any) {
			console.error(error);
		}
	};

	// // 환경데이터 조회 API
	// const getPointavg = async (data: PointavgType) => {
	// 	try {
	// 		// const response = await axios.post(`/ifactory/api/record/pointavg`, data);
	// 		// query parameter로 변경
	// 		const response = await axios.get(`/ifactory/api/record/pointavg?tagIds=${data.tagIds}&startDateTime=${data.startDateTime}&endDateTime=${data.endDateTime}&type=${data.type}&stdTime=${data.stdTime}`);
	// 		return response.data;
	// 	} catch (error: any) {
	// 		console.error(error);
	// 	}
	// };

	//! React Hook
	// mount 시 실행되는 함수
	useEffect(() => {
		// 농장 정보를 기반으로 사육실 정보를 가져옴
		const placeId = targetFarmInfoMemo.placeId;
		getPlaceInfo(placeId).then((response) => {
			setPlaceList(response);
		});
	}, []);

	// select Tag가 변경될 때마다 환경데이터 조회
	// useEffect(() => {
	// 	const changeUnitForRequest = (unit: string) => {	
	// 		switch (unit) {
	// 			case '시간':
	// 				return 'hourly';
	// 			case '일':
	// 				return 'daily';
	// 			case '주':
	// 				return 'weekly';
	// 			case '월':
	// 				return 'monthly';
	// 			default:
	// 				return 'hourly';
	// 		}
	// 	};

	// 	// selectTagList가 변경될 때마다 환경데이터 조회
	// 	if (selectTagList.length > 0) {
	// 		const tagIds = selectTagList.map((tag) => tag.tagId);
	// 		const data = {
	// 			tagIds: tagIds,
	// 			startDateTime: chartStartDate,
	// 			endDateTime: chartEndDate,
	// 			type: changeUnitForRequest(chartUnit),
	// 			stdTime: chartTime,
	// 		};
	// 		getPointavg(data).then((response) => {
	// 			setChartEnvirData(response);
	// 		});
	// 	}
	// }, [selectTagList, chartStartDate, chartEndDate, chartUnit, chartTime]);


	//! fn
	// 농장을 선택했을 때 실행되는 함수
	const handleFarmSelect = (farmId: number) => {
		return () => {
			setSelectFarm(farmId);
			// 선택된 사육실, 사육구역 정보를 초기화
			setSelectPlace(0);
			setSelectPlacePart(0);
			// 사육구역 List 초기화
			setPlacePartList([]);

			getPlaceInfo(farmId).then((response) => {
				setPlaceList(response);
			});

			getTag(farmId).then((response) => {
				setEnvirDataList(response);
			});
		};
	};

	// 사육실을 선택했을 때 실행되는 함수
	const handlePlaceSelect = (placeId: number) => {
		return () => {
			setSelectPlace(placeId);
			// 선택된 사육구역 정보를 초기화
			setSelectPlacePart(0);

			getPlaceInfo(placeId).then((response) => {
				setPlacePartList(response);
			});

			getTag(placeId).then((response) => {
				setEnvirDataList(response);
			});
		};
	};

	// 사육구역을 선택했을 때 실행되는 함수
	const handlePlacePartSelect = (placeId: number) => {
		
		return () => {

			// setSelectTagList([]);
			// setTemperatureTags([]);
			// setHumidityTags([]);
			// setCO2Tags([]);
			// setEtcTags([]);
			
			setSelectPlacePart(placeId);

			getTag(placeId).then((response) => {
				setEnvirDataList(response);
			});
		};
	};

	useEffect(() => {
		// console.log("Updated selectTempTags", selectTempTags);
	}, [selectTempTags]);
	
	useEffect(() => {
		// console.log("Updated selectHumidTags", selectHumidTags);
	}, [selectHumidTags]);
	
	useEffect(() => {
		// console.log("Updated selectCo2Tags", selectCo2Tags);
	}, [selectCo2Tags]);
	
	useEffect(() => {
		// console.log("Updated selectEtcTags", selectEtcTags);
	}, [selectEtcTags]);
	
	useEffect(() => {
		// console.log("Updated selectTagList", selectTagList);
	}, [selectTagList]);

	const handleTagSelect = (tag: any) => {
		return () => {

			let updatedTagList;
			console.log("tag.type ::", tag.type);
			
			switch (tag.type) {
				case 'TEMP':
					if (selectTempTags.some(item => item.tagId === tag.tagId)) {
						updatedTagList = selectTempTags.filter(item => item.tagId !== tag.tagId);
						setTemperatureTags(updatedTagList);
					} else {
						updatedTagList = [...selectTempTags, tag];
						setTemperatureTags(updatedTagList);
					}
					break;
				case 'HUMID':
					if (selectHumidTags.some(item => item.tagId === tag.tagId)) {
						updatedTagList = selectHumidTags.filter(item => item.tagId !== tag.tagId);
						setHumidityTags(updatedTagList);
					} else {
						updatedTagList = [...selectHumidTags, tag];
						setHumidityTags(updatedTagList);
					}
					break;
				case 'CO2':
					if (selectCo2Tags.some(item => item.tagId === tag.tagId)) {
						updatedTagList = selectCo2Tags.filter(item => item.tagId !== tag.tagId);
						setCO2Tags(updatedTagList);
					} else {
						updatedTagList = [...selectCo2Tags, tag];
						setCO2Tags(updatedTagList);
					}
					break;
				default:
					if (selectEtcTags.some(item => item.tagId === tag.tagId)) {
						updatedTagList = selectEtcTags.filter(item => item.tagId !== tag.tagId);
						setEtcTags(updatedTagList);
					} else {
						updatedTagList = [...selectEtcTags, tag];
						setEtcTags(updatedTagList);
					}
					break;
			}

			// 선택된 tagId가 selectTagList에 없으면 추가, 있으면 삭제
			if (selectTagList.some((item) => item.tagId === tag.tagId)) {
				setSelectTagList(selectTagList.filter((item) => item.tagId !== tag.tagId));
			} else {
				setSelectTagList([...selectTagList, tag]);
			}

		};
	};

	const removeFromAllSelectTagLists = (tagIdToRemove: any) => {
		// Temperature Tags
		setTemperatureTags(selectTempTags.filter(item => item.tagId !== tagIdToRemove));
	
		// Humidity Tags
		setHumidityTags(selectHumidTags.filter(item => item.tagId !== tagIdToRemove));
	
		// CO2 Tags
		setCO2Tags(selectCo2Tags.filter(item => item.tagId !== tagIdToRemove));
	
		// Etc Tags
		setEtcTags(selectEtcTags.filter(item => item.tagId !== tagIdToRemove));

		if (selectTagList.some((item) => item.tagId === tagIdToRemove.tagId)) {
			setSelectTagList(selectTagList.filter((item) => item.tagId !== tagIdToRemove.tagId));
		}
	};

	useEffect(() => {
		// chartUnit이 시간이라면 chartTime을 초기화
		if (chartUnit === '시간') {
			setChartTime(dayjs().format('HH:mm'));
		}
	}, [chartUnit]);

	//! 확인

	//! 임시 (Chart 테스트)
	// 오늘 날짜 기준으로 startDate는 한달전, endDate는 오늘로 설정
	const startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
	const endDate = dayjs().format('YYYY-MM-DD');

	useEffect(() => {
		setChartStartDate(startDate);
		setChartEndDate(endDate);
	}, []);

	//! render
	return (

		/**
		 * 1. 불러온 placeList를 기반으로 사육실 목록을 토글할 수 있는 버튼 구성.
		 * 2. 이후에 사육실을 클릭하면 해당 사육실 기반으로 사육구역을 토글할 수 있는 버튼 구성
		 * 3. 위 1,2번을 통해 선택된 사육구역에 따른 환경 정보를 토글할 수 있는 버튼 구성
		 * 4. 위 3번을 통해 선택된 환경 정보를 나타내주는 탭 구성
		 *  */
		<EnvirdataCrossConStyle>
			<Title>사육환경별 그래프</Title>

			<SelectOptionDivStyle>
				{/* 농장 구성 */}
				<SelectOptionBoxStyle>
					<p>농장</p>
					<ul>
						<li>
							<button
								className={selectFarm === targetFarmInfoMemo.placeId ? 'active' : ''}
								onClick={handleFarmSelect(targetFarmInfoMemo.placeId)}
							>{targetFarmInfoMemo.name}</button>
						</li>
					</ul>
				</SelectOptionBoxStyle>

				{/* 사육실 구성 */}
				<SelectOptionBoxStyle>
					<p>사육실</p>
					<ul>
						{placeList.map((place, idx) => {
							return (
								<li key={idx}>
									<button
										className={selectPlace === place.placeId ? 'active' : ''}
										onClick={handlePlaceSelect(Number(place.placeId))}>
										{place.name}
									</button>
								</li>
							);
						})}
					</ul>
				</SelectOptionBoxStyle>

				{/* 사육구역 구성 */}
				<SelectOptionBoxStyle>
					<p>사육구역</p>
					<ul>
						{placePartList.map((place, idx) => {
							return (
								<li key={idx}>
									<button
										className={selectPlacePart === place.placeId ? 'active' : ''}
										onClick={handlePlacePartSelect(Number(place.placeId))}>
										{place.name}
									</button>
								</li>
							);
						})}
					</ul>
				</SelectOptionBoxStyle>

				{/* 환경 정보 구성 */}
				<TagListStyle>
					<ul>
						{envirDataList.map((env, idx) => {
							return (
								<li key={idx}>
									<button type="button"
										onClick={handleTagSelect(env)}
										className={selectTagList.some(tag => tag.tagId === env.tagId) ? 'active' : ''}>
										{env.name}
									</button>
								</li>
							);
						})}
					</ul>
				</TagListStyle>
			</SelectOptionDivStyle>

			<SelectedTagListStyle>
				{/* 선택된 환경 정보에 따른 그래프 */}
				<ul>
					{
						selectTagList.map((tag, idx) => {
							return (
								<li key={idx}>
									{/* span에 text를 button에 X버튼을 부여하고 X버튼을 클릭할 시 해당 tagId의 요소를 선택해제한다. */}
									<span>{tag.name}</span>
									<button type="button" className='close-tab'
										onClick={() => {
											setSelectTagList(selectTagList.filter(item => item.tagId !== tag.tagId));
											removeFromAllSelectTagLists(tag.tagId); // 여기서 모든 상태 변수에서 제거
										}}
									>
										✖
									</button>
								</li>
							);
						})
					}
				</ul>
			</SelectedTagListStyle>



			<ChartBoxStyle>
				<ChartBoxOptionDivStyle>
					<div className='searchDateOption'>
						<p>조회일자</p>
						<input
							type="date"
							name="startDateTime"
							value={chartStartDate}
							onChange={(e) => setChartStartDate(e.target.value)}
						/>
						<span> ~ </span>
						<input
							type="date"
							name="endDateTime"
							value={chartEndDate}
							onChange={(e) => setChartEndDate(e.target.value)}
						/>
					</div>

					<div className='searchUnitOption'>
						<p>단위</p>
						<ul>
							{chartUnitList.map((unit, idx) => {
								return (
									<li key={idx}>
										<button
											className={chartUnit === unit ? 'active' : ''}
											onClick={() => setChartUnit(unit)}
										>{unit}</button>
									</li>
								);
							})}
						</ul>
					</div>

					{/* chartUnit이 시간이 아니라면 생성 */}
					{chartUnit !== '시간' &&
						<div className='searchTimeOption'>
							<p>조회시간</p>
							<input
								type="time"
								name="stdTime"
								value={chartTime}
								onChange={(e) => setChartTime(e.target.value)}
							/>
						</div>
					}
				</ChartBoxOptionDivStyle>

			
				{selectTempTags.length > 0 && (
					<LineChart
						temperatureTags={selectTempTags}
						startDate={chartStartDate}
						endDate={chartEndDate}
						stdTime={chartTime}
						type={chartUnit}
					/>
				)}
				{selectHumidTags.length > 0 && (
					<LineChart2
						humidityTags={selectHumidTags}
						startDate={chartStartDate}
						endDate={chartEndDate}
						stdTime={chartTime}
						type={chartUnit}
					/>
				)}
				{selectCo2Tags.length > 0 && (
					<LineChart3
						co2Tags={selectCo2Tags}
						startDate={chartStartDate}
						endDate={chartEndDate}
						stdTime={chartTime}
						type={chartUnit}
					/>
				)}
				{selectEtcTags.length > 0 && (
					<LineChart4
						elseTags={selectEtcTags}
						startDate={chartStartDate}
						endDate={chartEndDate}
						stdTime={chartTime}
						type={chartUnit}
					/>
				)}
				


			</ChartBoxStyle>

		</EnvirdataCrossConStyle>
	);
};

export default EnvirdataCrossCon;

const EnvirdataCrossConStyle = styled.div`
	// 태그의 기본 설정 reset
	p, ul, li, button{
		margin: 0;
		padding: 0;
		border: none;
		list-style: none;
		text-decoration: none;
		font-size: 1em;
		font-weight: normal;
		color: #333;
		background-color: transparent;
	}

	padding: 20px 40px 30px 40px;
`;

const Title = styled.div`
	font-size: 23px;
  color: #2a3a4b;
  margin-bottom: 20px;
`;

const SelectOptionDivStyle = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-direction: column;

	border : 1px solid #ddd;

	>div{
		&:not(:last-child){
			border-bottom: 1px solid #ddd;
		};
	}
	
	
`;

const SelectOptionBoxStyle = styled.div`
	width: 100%;
	display: flex;
	align-items: stretch;

	p{
		min-height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.9em;
		font-weight: bold;
		background-color: #eee;
		padding: 0 10px;
		min-width: 100px;
	}
	ul{
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		width: 100%;
		padding: 5px;

		li{
			padding: 5px;
			
			button{
				font-size : 0.9em;
				padding: 8px;
				border-radius: 8px;
				background-color: #eee;
				&:hover{
					cursor: pointer;
					background-color: #73972c;
					color: white;
				}
				&.active{
					background-color: #73972c;
					color: white;
				}
			}
		}
	}
`;

const TagListStyle = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	min-height: 40px;

	ul{
		display: flex;
		flex-wrap: wrap;
		padding: 10px;
		li{
			&:not(:last-child){
				margin-right: 10px;
			}
			button{
				font-size : 0.75em;
				padding: 8px;
				border-radius: 8px;
				background-color: #fff;
				border: 1px solid #d9d9d9;
				&:hover{
					cursor: pointer;
					color: #73972c;
					font-weight: bold;
				}
				&.active{
					color: #73972c;
					font-weight: bold;
				}
				&::before{
					content: '# ';
				}
			}
		}
	}
`;


const SelectedTagListStyle = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	margin-top: 16px;
	border-top: 4px solid #ddd;
	border-bottom: 1px solid #ddd;
	background-color: #c6c6c630;

	ul{
		display: flex;
		flex-wrap: wrap;
		padding: 8px 10px 0px 10px;
		li{
			padding: 4px 8px;
			border-radius: 8px;
			background-color: #73972c;
			color: white;

			display: flex;
			align-items: center;

			margin-bottom: 8px;

			&:not(:last-child){
				margin-right: 10px;
			}
			span{
				font-size : 0.75em;
				
				&::after{
					content: '｜';
					margin: 0 5px;
				}
			}
			button{
				font-size : 0.75em;
				color: white;
				padding: 2px;
				&:hover{
					cursor: pointer;
					color: #fff;
					transform: rotate(90deg);
					transition: all 0.3s ease;
				}
			}
		}
	}
`;

const ChartBoxStyle = styled.div`
	width: 100%;
	/* height: 500px; */
	padding: 10px;
	border: 1px solid #ddd;


`;

const ChartBoxOptionDivStyle = styled.div`
/* 오른쪽으로 이동 */
	display: flex;
	justify-content: flex-end;
	align-items: center;
	width: 100%;
	margin-bottom: 10px;
	flex-wrap: wrap;
	>div{
		display: flex;
		align-items: center;
		&:not(:last-child){
			margin-right: 20px;
		}

		&.searchDateOption{
			input{
				padding: 8px;
				border-radius: 8px;
				border: 1px solid #ddd;
			}
			span{
				margin: 0 10px;
			}
		}
	}
	p{
		font-size: 0.9em;
		font-weight: bold;
		margin-right: 10px;
	}
	ul{
		display: flex;
		li{
			&:not(:last-child){
				margin-right: 10px;
			}

			button{
				font-size: 0.9em;
				padding: 8px;
				border-radius: 8px;
				background-color: #eee;
				&:hover{
					cursor: pointer;
					background-color: #73972c;
					color: white;
				}
				&.active{
					background-color: #73972c;
					color: white;
				}
			}
		}
	}

`; 